module.exports = __webpack_public_path__ + "img/tick_red.c901fc31.svg";